import { render, staticRenderFns } from "./FeedBackRating.vue?vue&type=template&id=2d16c1bc&scoped=true&"
import script from "./FeedBackRating.vue?vue&type=script&lang=js&"
export * from "./FeedBackRating.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackRating.vue?vue&type=style&index=0&id=2d16c1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16c1bc",
  null
  
)

export default component.exports